import React, { useEffect, useRef, useState } from 'react'
import Input from '../../master/Input';
import Plate from '../../expert/Plate';
import ShowPlate from '../../../pages/expert/ShowPlate';
import { useTranslation } from 'react-i18next';
import CarInfoIcon from '../../../assets/images/icons/car-info-orange.png'
import CarSelect from '../../master/CarSelect';
import SearchablePicker from '../../master/SearchablePicker';
import { getDirection, pexios, toast, UserLabel, validate } from '../../../utils/functions';
import ContactBox from '../../master/ContactBox';
import HeaderIcon from '../../../assets/images/header-icon/car-info.png'
import { useSelector } from 'react-redux';

export default function CarInfo({data,changeData,handleEditInfo}) {
    const {routerData} = useSelector(store=>store)
    const {user_type,searchType,insurance_type} = useSelector(store => store.accidentInfo);
    const [supportCall,setSupportCall] = useState(false)
    const [colors, setColors] = useState([]);
    const [cabinType, setCabinType] = useState([]);
    const form =useRef(null);
    const { t, i18n } = useTranslation();
    const using = [t('Personal'), t('Taxi'), t('Online taxi'), t('Suburban taxi'), t('Personal passenger')];
    useEffect(() => {
        pexios('api/get_color')
            .then(res => {
                setColors(res.data);
            });
    }, []);
    useEffect(() => {
        pexios('api/get_coding_data/cabin')
            .then(res => {
                setCabinType(res.data);
            });
    }, []);
    function Submit(type) {
        let error = ''
        if(form && form.current) error= validate(form);
        if (error) {
            // toast(`فیلد های اجباری ${err} را پر کنید.`, 'error');
            toast(`فیلد های اجباری ${error} را پر کنید.`, 'error');
            return
        } 
        handleEditInfo(type)
    }
  return (
    <>
        {supportCall && <ContactBox isOpen={supportCall} close={()=>setSupportCall(false)}/>}
                <div className='title-image'>
                    <img src={HeaderIcon} alt="icon"/>
                </div>
                <p className='guide-text mx10 mt10'>لطفا مشخصات خودرو {insurance_type === 'third' && UserLabel(user_type)} را بررسی و در صورت نیاز تکمیل نمایید.</p>
                {!!((data?.final_check)
                // ||(searchType !== 'chassis'&& foundCar)
                ) 
                &&
                <>
                <div className='plate-container mt10'>
                    <ShowPlate
                        plate={{
                            plate_iran: data.plate_iran,
                            plate_left: data.plate_left,
                            plate_center: data.plate_center,
                            plate_right:  data.plate_right,
                            plate_type: data.plate_type
                        }}
                        />
                    </div>
                <div className='car-info br5 p10 mt10'>
                        <div className='d-flex align-items-center mr10 text-right'>
                            <p className='rtl'>{data.title}</p>
                            <img className='ml10' src={CarInfoIcon}/>
                        </div>
                    </div>
                <div className='edit-text mt10'>
                    <p className='m5 text-center'> در صورت مغایرت اطلاعات ،با <span className='colorful-text' onClick={()=> setSupportCall(true)}>پشتیبانی</span> تماس حاصل نمایید.</p>
                </div>
                </>}
                {
                // (searchType === 'chassis') 
                !!(!data?.final_check) &&
                    <div className='row text-right' ref={form}>
                        <Plate
                            type={data.plate_type || 'car'}
                            plate={{
                                plate_iran: data.plate_iran,
                                plate_left: data.plate_left,
                                plate_center: data.plate_center,
                                plate_right: data.plate_right,
                            }}
                            change={(value, name) => changeData(value, name,'car')}
                            required={!data?.final_check}
                            // required={!foundCar}
                            // fixed={foundCar&& data?.final_check}
                            fixed={searchType === 'pelak'}
                            withoutMotor={routerData.type === 'register'}
                        />
                        {/* <Input
                            label='شماره شاسی'
                            value={data.chassis_number}
                            // disabled={data.final_check}
                            onChange={value => changeData(value, 'chassis_number')}
                            className='text-left'
                            disabled={searchType !== 'pelak'}
                            required={!data?.final_check}
                            // required={!foundCar}
                        /> */}
                        <CarSelect
                            data={{
                                carType: data.car_type_id,
                                carBrand: data.car_brand_id,
                                carModel: data.car_model_id,
                            }}
                            // disabled={foundCar&&data?.final_check}
                            onChange={(value, type) => changeData(value, type,'car')}
                            required={!data?.final_check}
                            // required={!foundCar}
                            PlateType={data?.plate_type}
                        />
                        <SearchablePicker
                            label={t('Car color')}
                            value={data.car_color_id}
                            data={colors}
                            titleKey='name'
                            valueKey='id'
                            rtl={getDirection(i18n.language) ==='rightToLeft'}
                            // disabled={foundCar&&data?.final_check}
                            onSelect={color => changeData(color, 'car_color_id','car')}
                            required={!data?.final_check}
                            // required={!foundCar}
                        />
                        <Input
                            label={t('Motor number')}
                            value={data.motor_number}
                            // disabled={foundCar&&data?.final_check}
                            onChange={value => changeData(value, 'motor_number','car')}
                            className='text-left'
                            required={!data?.final_check}
                            // required={!foundCar}
                            disabled={searchType === 'motor&chassis'}
                        />
                        <Input
                            label={t('VIN')}
                            value={data.vin_number}
                            // disabled={foundCar&&data?.final_check}
                            onChange={value => changeData(value, 'vin_number','car')}
                            className='text-left'
                            required={!data?.final_check}
                            // required={!foundCar}
                        />
                        <Input
                            label={t('Produce year')}
                            value={data.production_year}
                            mode='numeric'
                            // disabled={foundCar&&data?.final_check}
                            onChange={value => changeData(value, 'production_year','car')}
                            className='text-left'
                            required={!data?.final_check}
                            // required={!foundCar}
                            maxLength={4}
                        />
                        {routerData.type === 'register' &&
                        <>
                            {/* <SearchablePicker
                                label='نوع کابین'
                                value={data.cabin_type_id}
                                data={cabinType}
                                onSelect={value => changeData(value, 'cabin_type_id','car')}
                                rtl
                                titleKey='title'
                                valueKey='id'
                                required
                                // required={!foundCar}
                            /> */}
                            <SearchablePicker
                                label={t('Using')}
                                value={data.using}
                                data={using}
                                rtl={getDirection(i18n.language) ==='rightToLeft'}
                                required
                                onSelect={ using => changeData(using, 'using','car') }
                            />
                        </>
                        }
                        </div>
                }
                
                <div className='d-flex justify-center mt20'>
                    {!!(data?.final_check) &&
                    <button 
                        className={`btn btn-circle w-50 btn-orange btn-bold m10`} 
                        onClick={()=>setSupportCall(true)}>  عدم تایید و مغایرت</button>
                    }
                    <button 
                        className={`btn btn-circle w-50 btn-white-purple btn-bold m10`} 
                        onClick={()=> Submit('car')}
                        >تایید و ادامه 
                    </button>
                </div>                        
            </>
  )
}

